//ป.6 week 5
export const LessonArray = [
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade4%2Fweek5%2F1.m4a?alt=media&token=9c5a9add-5df6-4a5f-a60b-24e31a2aec09",
    content_id: 1,
    header: true,
    label1: {
      text: "ควรทำตัวอย่างไรเพื่อหลีกเลี่ยงต่อสถานการณ์สุ่มเสี่ยงกับสารเสพติด ",
      highlight: true,
    },
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F3.m4a?alt=media&token=853a208d-8219-4f79-93c2-c2f5c9cf6e1f",
    content_id: 2,
    label1: {
      text: "การปฏิเสธเป็นทักษะชีวิตที่สำคัญ",
      highlight: true,
    },
    label2: {
      text: "และจำเป็นที่ต้องปฏิบัติเพื่อป้องกัน",
      highlight: false,
    },
    label3: {
      text: "สถานการณ์เสี่ยงที่อาจจะเป็นภัยกับตนเอง",
      highlight: false,
    },
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F4.m4a?alt=media&token=44065822-794e-4d45-991c-79dc268ba700",
    content_id: 3,
    label1: {
      text: "การรู้จักปฏิเสธอย่างถูกวิธี",
      highlight: true,
    },
    label2: {
      text: "จะช่วยให้ทุกคนรอดจากภัยเสี่ยงต่างๆ",
      highlight: false,
    },
    label3: {
      text: "และยังช่วยรักษาสัมพันธภาพที่ดีกับผู้อื่นด้วย",
      highlight: false,
    },
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F5.m4a?alt=media&token=f1f39759-57b2-4e49-98f8-3909e862288f",
    content_id: 4,
    label1: {
      text: "หลักการปฏิเสธ",
      highlight: true,
    },
    label2: {
      text: "เรามาดูว่ามีอะไรกันบ้างกันครับ",
      highlight: false,
    },
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F6.m4a?alt=media&token=170acaee-18a1-43fe-8582-168730da61b9",
    content_id: 5,
    label1: {
      text: "ปฏิเสธอย่างจริงจังทั้งท่าทางคำพูด",
      highlight: false,
    },
    label2: {
      text: "และน้ำเสียงเพื่อแสดงความตั้งใจอย่างชัดเจน",
      highlight: false,
    },
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F7.m4a?alt=media&token=c0da5ac6-38a1-449a-9da2-2d769b8eb9c7",
    content_id: 6,
    img: "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/character%2Fstudent.png?alt=media&token=6b35e8ac-b06a-4359-a1eb-519c92a8196c",
    label1: {
      text: "“ฉันไม่ดื่มด้วยหรอกนะ”",
      highlight: true,
    },
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F8.m4a?alt=media&token=b4c0d715-a103-4543-95e1-66b55c74022b",
    content_id: 7,
    label1: {
      text: "ใช้ความรู้สึกเป็นข้ออ้างพร้อมเหตุผล",
      highlight: false,
    },
    label2: {
      text: "เพราะการอ้างความรู้สึกจะทำให้โต้แย้งได้ยากขึ้น",
      highlight: false,
    },
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F9.m4a?alt=media&token=56ed4b0e-6b61-4d2e-8e24-0af5573e67a4",
    content_id: 8,
    img: "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/character%2Fstudent.png?alt=media&token=6b35e8ac-b06a-4359-a1eb-519c92a8196c",
    label1: {
      text: "“ฉันไม่สบายใจเลย",
      highlight: true,
    },
    label2: {
      text: "เพราะอาจทำให้คนเข้าใจผิดได้”",
      highlight: false,
    },
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F10.m4a?alt=media&token=0066e2e3-5de1-4537-a41a-eb2e9eebf9ab",
    content_id: 9,
    label1: {
      text: "การบอกปฏิเสธให้ชัดเจน",
      highlight: true,
    },
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F11.m4a?alt=media&token=2056488c-7860-4193-8ab4-36f1c0545932",
    content_id: 10,
    label1: {
      text: "“ฉันไม่ไปด้วยหรอก” “ฉันขอไม่ไป”",
      highlight: true,
    },
    label2: {
      text: "“ผมไม่ชอบ”",
      highlight: true,
    },
    label3: {
      text: "“ฉันขอไม่ไปดื่มนะ”",
      highlight: true,
    },
    img: "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/character%2Fstudent.png?alt=media&token=6b35e8ac-b06a-4359-a1eb-519c92a8196c",
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F12.m4a?alt=media&token=d8200348-e450-43c0-95ee-e76bfe59bcbc",
    content_id: 11,
    label1: {
      text: "การแสดงอาการขอบคุณเมื่อผู้ชวนยอมรับ",
      highlight: false,
    },
    label2: {
      text: "และเป็นการรักษาน้ำใจของผู้ชวน",
      highlight: false,
    },
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F13.m4a?alt=media&token=8d215019-a118-4650-a3e5-07f331dfb353",
    content_id: 12,
    label1: {
      text: "“เธอคงเข้าใจนะ”",
      highlight: true,
    },
    label2: {
      text: "“ขอบคุณมากที่เธอเข้าใจ”",
      highlight: true,
    },
    img: "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/character%2Fstudent.png?alt=media&token=6b35e8ac-b06a-4359-a1eb-519c92a8196c",
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F14.m4a?alt=media&token=dceed36a-f86b-4f42-90ae-0e4c2f05eca9",
    content_id: 13,
    label1: {
      text: "เมื่อถูกเซ้าซี้เราควรยืนยันการปฏิเสธ",
      highlight: false,
    },
    label2: {
      text: "และหาทางออกโดยเลือกวิธีต่อไปนี้",
      highlight: false,
    },
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F15.m4a?alt=media&token=be12f662-c3c2-40b4-a292-cfdc8079fb06",
    content_id: 14,
    label1: {
      text: "ปฏิเสธซ้ำโดยไม่ต้องใช้ข้ออ้าง",
      highlight: false,
    },
    label2: {
      text: "พร้อมทั้งบอกลาแล้วเดินจากไปทันที",
      highlight: false,
    },
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F16.m4a?alt=media&token=d4b9407a-b846-452f-9b74-48e6e36ecd53",
    content_id: 15,
    label1: {
      text: "การต่อรองโดยการชักชวนให้ทำกิจกรรมอื่นทดแทน",
      highlight: false,
    },
    label2: {
      text: "พร้อมทั้งบอกลาแล้วเดินจากไปทันที",
      highlight: false,
    },
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F17.m4a?alt=media&token=55dad8bc-01dd-4caa-85e5-8a723362261d",
    content_id: 16,
    label1: {
      text: "การผัดผ่อนขอยืดระยะเวลาออกไป",
      highlight: false,
    },
    label2: {
      text: "เพื่อให้ผู้ชวนเปลี่ยนความตั้งใจ เช่น",
      highlight: false,
    },
    label3: {
      text: " เอาไว้วันหลังดีกว่า ไว้โอกาสหน้าก็แล้วกันน",
      highlight: false,
    },
  },
];

//ป.6 week5
export const QuizArray = [
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F6-5.1.m4a?alt=media&token=038aa729-747a-4ed2-8719-af54cc263cc5",
    question_id: 1,
    quizType: 2,
    question_label:
      "เมื่อมีเพื่อนๆต้องการให้น้องๆดื่มเหล้าฉลองในวันเกิด น้องๆจะพูดกับเพื่อนว่าอย่างไรดีคะ",
    hint: 1,
    choices: [
      {
        id: 1,
        additionImg: "",
        choice_label:
          "ขอบใจที่ชวนนะแต่เราแสบท้องเวลาดื่มเลยไปไม่ได้เธอคงเข้าใจเรานะ",
      },
      {
        id: 2,
        additionImg: "",
        choice_label:
          "เราไม่ดื่มเหล้าขอโทษด้วยนะเพราะเหล้ามันทำให้เราเสียคนได้นะเพื่อนๆ",
      },
    ],
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F6-5.2.m4a?alt=media&token=9066ccf5-9c59-47bc-a9f4-2401e7961bcc",
    question_id: 2,
    quizType: 2,
    question_label:
      "เมื่อมีเพื่อนชวนน้องๆไปนั่งเล่นใกล้กับร้านขายเหล้าน้องๆจะพูดกับเพื่อนว่าอย่างไรดีคะ",
    hint: 1,
    choices: [
      {
        id: 1,
        additionImg: "",
        choice_label: "เราไปไม่ได้นะต้องรีบกลับไปช่วยงานแม่ที่บ้านขอโทษด้วย",
      },
      {
        id: 2,
        additionImg: "",
        choice_label: "เราไปนั่งแป๊ปเดียวแล้วกลับกันนะเพื่อนๆ",
      },
    ],
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F6-5.3.m4a?alt=media&token=95ccbada-6b10-474b-bc88-e84746ebe03a",
    question_id: 3,
    quizType: 2,
    question_label:
      "เมื่อมีเพื่อนมาท้าให้น้องๆทดลองใช้ยาบ้าน้องๆจะพูดกับเพื่อนว่าอย่างไรดีคะ",
    hint: 1,
    choices: [
      {
        id: 1,
        additionImg: "",
        choice_label:
          "พูดด้วยท่าทางจริงจังว่า “ฉันไม่สนใจที่จะใช้ยาบ้าเพราะมันไม่ดีต่อร่างกายของเรา”",
      },
      {
        id: 2,
        additionImg: "",
        choice_label:
          "พูดด้วยท่าทีผ่อนคลายว่า “ถ้าโตกว่านี้ค่อยทดลองใช้กันดีกว่านะเพื่อนๆ”",
      },
    ],
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F6-5.4.m4a?alt=media&token=2a790b2e-c04a-45c4-9fc5-135000686254",
    question_id: 4,
    quizType: 2,
    question_label:
      "เมื่อเพื่อนชวนน้องๆไปแอบดูคนลักลอบซื้อขายยาเสพติด น้องๆจะบอกเพื่อนว่าอย่างไรดีคะ",
    hint: 1,
    choices: [
      {
        id: 1,
        additionImg: "",
        choice_label:
          "บอกเพื่อนว่าเราไม่สบายใจที่จะไปเพราะอาจทำให้คนอื่นเข้าใจเราผิดได้",
      },
      {
        id: 2,
        additionImg: "",
        choice_label: "บอกเพื่อนว่าเรากลัวและไม่อยากไปดู",
      },
    ],
  },
  {
    audioLink:
      "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Fgrade6%2Fweek5%2F6-5.5.m4a?alt=media&token=3521bbea-8295-49c6-b9e6-5b86bf74f773",
    question_id: 5,
    quizType: 2,
    question_label:
      "เมื่อมีรุ่นพี่ชวนน้องๆไปทดลองสูบบุหรี่ไฟฟ้าหลังเลิกเรียนน้องๆจะบอกกับรุ่นพี่ว่าอย่างไรดีคะ",
    hint: 1,
    choices: [
      {
        id: 1,
        additionImg: "",
        choice_label: "พอดีต้องรีบไปพบครู ขอตัวก่อนนะคะ/ครับ",
      },
      {
        id: 2,
        additionImg: "",
        choice_label: "บุหรี่ไฟฟ้าคืออะไร คะ/ครับพอดีไม่เคยเห็นมาก่อน",
      },
    ],
  },
];
